export const tourData = [
  {
    id: 1,
    city: "San Miguel de Allende",
    img: "./img/sanmiguel.jpg",
    name: "San Miguel Walking Tour",
    price: 55,
    info:
      "Walking through the historic district of San Miguel de Allende is a great way to discover this town’s beautiful hidden enclaves and must-see attractions alike. This private San Miguel walking tour introduces you to the city’s charms with unparalleled personal attention."
  },
  {
    id: 2,
    city: "San Miguel de Allende",
    img: "./img/Atotonilco.jpg",
    name: "Dolores Hidalgo & Sanctuary of Atotonilco",
    price: 160,
    info:
      "Visit the beautiful town of Dolores Hidalgo, cradle of Mexico’s Independence movement. See it’s magnificent church, it’s museums, local crafts and taste their delicious hand made ice cream flavors. After that, we’ll see the incredible paintings at the Atotonilco Sanctuary, a UNESCO World Heritage site"
  },
  {
    id: 3,
    city: "Guanajuato",
    img: "./img/diegorivera.jpg",
    name: "Guanajuato Diego Riviera and Frida Kahlo Tour",
    price: 34,
    info:
      "Frida Kahlo and Diego Rivera helped to define Mexican modernism while engaged in a tumultuous romance. On this 2-hour tour we’ll get a glimpse into the life of Mexican artists.Our visit will take us to the Diego Riviera Museum, his former abode and where many of his works were created. We will get a sense of how he once lived and worked. We’ll engage directly with his history as we surround ourselves by his artwork, clothing, photos"
  },
  {
    id: 4,
    city: "Penjamo",
    img: "./img/corralejo.jpg",
    name: "Tequilera Corralejo",
    price: 30,
    info:
      "Hacienda Corralejo is a great place to meet , to go with family, friends and enjoy a unique place . As you approach , you begin to feel a special thrill , you get to see his tall, slender palm trees around, and welcoming visitors. Since you have accessed the Treasury, visitors are welcomed by a group of guides that lead to know each of their spaces and especially the process that is Tequila Corralejo, the best Tequila of Mexico for the World."
  },
  {
    id: 4,
    city: "Guanajuato",
    img: "./img/callejoneadas.jpg",
    name: "Guanajuato Nightlife and Callejoneadas Tour",
    price: 34,
    info:
      "Join a traditional Callejoneadas and walk along the beautiful streets of Guanajuato while you listen to the musical performances of the Estudiantinas who accompany you. Singing both original and traditional Mexican songs, these young performers are dress in delightfully old fashioned clothing and play various instruments, including percussion and string instruments along with the accordion."
  },
  {
    id: 4,
    city: "San Miguel de Allende",
    img: "./img/tasteofsm.jpg",
    name: "Taste of San Miguel Food Tour",
    price: 52,
    info:
      "Discover San Miguel's most colorful flavors during a small-group walking tour led by a passionate food expert. Enjoy a variety of traditional Mexican culinary delights while supporting and interacting with the local food artisans.This food-tasting and cultural walking tour of San Miguel de Allende lets you admire Mexican culture from the perspective of a local, through delicious cuisine, rich history, and fascinating architecture. Suitable for all age groups, the tour whisks you away on a culinary journey from beginning to end."
  }
];
